var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHighlightMembershipCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 24.7l3.99 1.78v-5.99H15.5zm-4.99 1.78l3.99-1.78v-4.21h-3.99zm7.27-10.98L15 13.96l-2.78 1.53.53-3.25-2.25-2.3 3.1-.47L15 6.52l1.39 2.96 3.1.47-2.25 2.3.54 3.25zm7.7-11.98H4.52c-.55 0-1 .45-1 1v13.97c0 .55.45 1 1 1h20.96c.55 0 1-.45 1-1V4.52c0-.55-.45-1-1-1z"
  })));
}

export default SvgHighlightMembershipCard;